export default __webpack_public_path__ + "static/media/earnMoreBoxImg.bb34de86.png";